/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductVariantPriceScaleQueryResponse, GetShowProductVariantPriceScalePathParams, GetShowProductVariantPriceScaleQueryParams, GetShowProductVariantPriceScale404 } from "../../models/GetShowProductVariantPriceScale";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductVariantPriceScaleUrl({ code }: { code: GetShowProductVariantPriceScalePathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/variant-price-scale` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/variant-price-scale}
 */
export async function getShowProductVariantPriceScale({ code, params }: { code: GetShowProductVariantPriceScalePathParams["code"]; params: GetShowProductVariantPriceScaleQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductVariantPriceScaleQueryResponse, ResponseErrorConfig<GetShowProductVariantPriceScale404>, unknown>({ method : "GET", url : getGetShowProductVariantPriceScaleUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}